// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import router from './router'
import store from './store/index'
import { sync } from 'vuex-router-sync'

import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'

import axios from 'axios'
import VueAxios from 'vue-axios'

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function (searchElement, fromIndex) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined')
      }
      var o = Object(this)
      var len = o.length >>> 0
      if (len === 0) {
        return false
      }
      var n = fromIndex | 0
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0)
      while (k < len) {
        if (o[k] === searchElement) {
          return true
        }
        k++
      }
      return false
    }
  })
}

Vue.use(VueAxios, axios)
sync(store, router)
Vue.use(Element, { locale: locale, size: 'mini' })

Vue.filter('yen', value => {
  if (value === null) {
    return null
  } else if (!value) {
    return '0'
  }
  value = Math.floor(value)
  return String(value)
    .split('')
    .reverse()
    .join('')
    .match(/\d{1,3}/g)
    .join(',')
    .split('')
    .reverse()
    .join('')
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js